import React from 'react';
import { Star, Heart, MessageSquare, Zap } from 'lucide-react';
export function BetaSection() {
  const benefits = [{
    icon: Zap,
    text: 'Early access before public launch'
  }, {
    icon: MessageSquare,
    text: 'Direct influence on product direction'
  }, {
    icon: Heart,
    text: 'Priority personal support'
  }, {
    icon: Star,
    text: 'Early adopter pricing on launch'
  }];
  return <section className="py-20 px-6 max-w-4xl mx-auto" data-id="element-10">
      <div className="bg-[#2D2D2D] text-[#FAFAF8] rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-11">
        <div className="text-center mb-10" data-id="element-12">
          <h2 className="text-3xl font-bold mb-4" data-id="element-13">Join the Welma beta</h2>
          <p className="text-[#FAFAF8]/80 max-w-xl mx-auto" data-id="element-14">
            We're looking for thoughtful practitioners who want to help shape
            the future of solo practice management.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-10" data-id="element-15">
          <div className="space-y-4" data-id="element-16">
            <h3 className="font-semibold text-[#8B9D83] uppercase tracking-wider text-sm mb-4" data-id="element-17">
              What you get
            </h3>
            {benefits.map((benefit, index) => <div key={index} className="flex items-center" data-id="element-18">
                <benefit.icon className="w-5 h-5 text-[#8B9D83] mr-3" data-id="element-19" />
                <span data-id="element-20">{benefit.text}</span>
              </div>)}
          </div>

          <div className="space-y-4 md:border-l md:border-white/10 md:pl-8" data-id="element-21">
            <h3 className="font-semibold text-[#7B9AAA] uppercase tracking-wider text-sm mb-4" data-id="element-22">
              What we ask
            </h3>
            <ul className="space-y-4 list-disc list-inside text-[#FAFAF8]/90" data-id="element-23">
              <li data-id="element-24">Use Welma in your real daily practice</li>
              <li data-id="element-25">Share honest feedback on what works (and what doesn't)</li>
              <li data-id="element-26">Be patient as we polish the experience</li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}